import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import VideoFeature from '@features/video';
import { useDefaultVideoActions } from '@services/elearning-wp-remote';

function VisitorVideoPage() {
  const navigate = useNavigate();
  const { onElearningComplete, isLoading } = useDefaultVideoActions();

  return (
    <VideoFeature
      onElearningComplete={onElearningComplete}
      isLoading={isLoading}
      onPreviousPage={() => navigate(ROUTES.VR_REGISTER)}
    />
  );
}

export default VisitorVideoPage;
